import api from "../../index.js";

export const GetSupportTicketApi = (params) => api.get(`TicketMaster/GetTicketList-ByUserId?${params}`);
export const GetSupportTicketQueryTypeApi = (params) => api.get(`DropDown/Ticket-Query?${params}`);
export const GetSupportTicketPrioriytTypeApi = () => api.get('DropDown/Priority');
export const AddSupportTicketApi = (data) => api.post('TicketMaster/Generate-Ticket', data);
export const GetTicketByIdApi = (params) => api.get(`TicketMaster/GetTicket-ByTicketId?${params}`);
export const GetTicketChatApi = (data) => api.post('TicketMaster/AddOrGet-ChatByTicketId', data);
export const UpdateassingTicketApi = (data) => api.patch('TicketMaster/Notify-To-Admin', data);
